import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSportShield = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.394 2.605A2.08 2.08 0 0 0 19.931 2H4.069c-.555 0-1.077.218-1.463.605A2.05 2.05 0 0 0 2 4.067v4.328c0 2.933.875 5.756 2.532 8.168a14.4 14.4 0 0 0 6.72 5.294c.243.093.496.143.748.143s.505-.042.749-.143a14.4 14.4 0 0 0 6.72-5.294 14.3 14.3 0 0 0 2.53-8.168V4.067c0-.546-.21-1.067-.605-1.462m-11.413.656v16.613a12 12 0 0 1-1.261-.815V3.26zm-6.72 5.134V4.067a.8.8 0 0 1 .808-.807h.866v11.555a13.15 13.15 0 0 1-1.673-6.42m2.936 8.286V3.26h1.261v14.773c-.445-.42-.866-.866-1.261-1.353m14.541-8.286c0 2.672-.799 5.252-2.312 7.454a13.1 13.1 0 0 1-6.132 4.832.84.84 0 0 1-.588 0c-.16-.06-.312-.135-.463-.194V3.261h8.688c.21 0 .42.084.572.235a.82.82 0 0 1 .235.571z"
      />
    </svg>
  );
};
export default SvgSportShield;
